<template>
  <div>
    <p class="has-text-weight-bold mt-6">
      {{ $t("mp:page.application_details.statements.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("mp:page.application_details.statements.subtitle") }}
    </p>

    <template v-if="loaded">
      <template v-if="statementAcceptances && statementAcceptances.length > 0">
        <div
          class="columns setting-tile mx-0 my-2"
          v-for="acceptance in statementAcceptances"
          :key="acceptance.statementId"
        >
          <div class="column is-flex">
            <b-checkbox
              :name="acceptance.statementIdentifier"
              :disabled="acceptance.isRequired"
              :value="acceptance.isAccepted"
              @input="setAccepted($event, acceptance)"
            />
            <span>
              {{ acceptance.statementLabel }}

              <StatementReaderModal
                v-if="acceptance.documentId"
                :documentId="acceptance.documentId"
                :isRequiredToRead="false"
                :is-public="false"
                :can-cancel="true"
              />
              <StatementLink
                v-if="acceptance.link"
                :link="acceptance.link"
                :isRequiredToRead="false"
              />
            </span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="columns setting-tile mx-0 my-2">
          <div class="column">
            {{ $t("mp:page.application_details.statements.empty") }}
          </div>
        </div>
      </template>
    </template>

    <LoadingSkeleton v-else />
  </div>
</template>

<script>
import LoadingSkeleton from "../LoadingSkeleton";

export default {
  name: "ApplicationDetailsStatements",
  props: {
    applicationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      statementAcceptances: [],
    };
  },
  async mounted() {
    await this.$store.dispatch(
      "statements/statementsForApplication",
      this.applicationId
    );
    this.statementAcceptances = this.$store.getters[
      "statements/statementsForApplication"
    ](this.applicationId);
    this.loaded = true;
  },
  components: {
    LoadingSkeleton,
    StatementReaderModal: () =>
      import("@/components/statement/StatementReaderModal.vue"),
    StatementLink: () => import("@/components/statement/StatementLink.vue"),
  },

  methods: {
    async setAccepted(checked, acceptance) {
      acceptance.isAccepted = checked;

      try {
        let request = {
          statementId: acceptance.statementId,
          applicationId: this.applicationId,
          isAccepted: checked,
        };
        await this.$store.dispatch("statements/acceptStatement", request);
      } catch (ex) {
        console.error("Statement Acceptance failed!");
      }
    },
  },
};
</script>
